/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// MEP (2026-10-27): load ONE Google map at a time instead of every store at once.
// The theme's homeMaps() initialises (and geocodes) a map for EVERY store block as
// soon as the Map section scrolls into view - ~30 billable map loads per page view.
// This wrapper only initialises the store that is currently shown, then initialises
// other stores on demand when they are clicked. Each canvas is initialised once.
(function () {
  if (typeof theme === "undefined" || typeof theme.homeMaps !== "function") return;

  // A canvas is "shown" when its holder (.js-map-media on desktop, or the
  // .js-map-info accordion item on mobile) carries the theme's js-active class.
  function isShown(canvas) {
    var holder = jQuery(canvas).closest(".js-map-media, .js-map-info");
    return holder.length > 0 && holder.hasClass("js-active");
  }

  // Already initialised canvases contain Google's .gm-style element.
  function hasMap(canvas) {
    return canvas.querySelector(".gm-style") !== null;
  }

  var originalHomeMaps = theme.homeMaps;

  theme.homeMaps = function () {
    originalHomeMaps.apply(this, arguments);

    var originalRunMap = theme.runMap;
    if (typeof originalRunMap !== "function") return;

    theme.runMap = function (mapId) {
      var canvas = mapId ? document.getElementById(mapId) : null;
      if (!canvas || hasMap(canvas) || !isShown(canvas)) return;
      originalRunMap.call(this, mapId);
    };

    // Runs after the theme's own click handler has switched the active store.
    jQuery(".js-map-trigger")
      .off("click.mepMaps")
      .on("click.mepMaps", function () {
        if (typeof window.google === "undefined" || !window.google.maps) return;
        jQuery(this)
          .closest(".js-map")
          .find(".js-map-ids")
          .each(function () {
            theme.runMap(this.id);
          });
      });
  };
})();